export default "__VITE_ASSET__yYXdW5rkm_8kj83UJpHkbQ__"